import { render, staticRenderFns } from "./downloadShipping.vue?vue&type=template&id=17a882a4&scoped=true&"
import script from "./downloadShipping.vue?vue&type=script&lang=js&"
export * from "./downloadShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a882a4",
  null
  
)

export default component.exports